import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: {
    id: 'frontbucket.repository.source.file.actions.edit',
    description: 'Action to return to editing a file',
    defaultMessage: 'Edit file',
  },
  preview: {
    id: 'frontbucket.repository.source.file.actions.preview',
    description: 'Action to preview the rendered markup for a file',
    defaultMessage: 'Preview',
  },
  viewEditDiff: {
    id: 'frontbucket.repository.source.file.actions.viewEditDiff',
    description:
      'Action to view a diff of unsaved changes made while editing a file',
    defaultMessage: 'View diff',
  },
});
